import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout } from "@/components/PublicLayout";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Structure from "@/pages/Structure";
import Vision from "@/pages/Vision";
import Media from "@/pages/Media";
import Volunteer from "@/pages/Volunteer";
import EventsPage from "@/pages/Events";
import NewsDetail from "@/pages/NewsDetail";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Members from "@/pages/admin/Members";
import Rewards from "@/pages/admin/Rewards";
import ExportHub from "@/pages/admin/ExportHub";
import Users from "@/pages/admin/Users";
import CommunityFeed from "@/pages/admin/CommunityFeed";
import AdminEvents from "@/pages/admin/Events";
import PressAdmin from "@/pages/admin/PressAdmin";

const publicPages = [
  ["/", <Home />],
  ["/about", <About />],
  ["/structure", <Structure />],
  ["/vision", <Vision />],
  ["/media", <Media />],
  ["/events", <EventsPage />],
  ["/news/:id", <NewsDetail />],
  ["/volunteer", <Volunteer />],
];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {publicPages.map(([path, el]) => (
              <Route key={path} path={path} element={<PublicLayout>{el}</PublicLayout>} />
            ))}

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="members" element={<Members />} />
              <Route path="feed" element={<CommunityFeed />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="press" element={<ProtectedRoute roles={["super_admin", "media_admin"]}><PressAdmin /></ProtectedRoute>} />
              <Route path="rewards" element={<ProtectedRoute superOnly><Rewards /></ProtectedRoute>} />
              <Route path="export" element={<ExportHub />} />
              <Route path="users" element={<ProtectedRoute superOnly><Users /></ProtectedRoute>} />
            </Route>
          </Routes>
          <WhatsAppButton />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
